import React, {Component} from 'react';
import SearchForm from './Search/SearchForm';
import SearchTable from './Search/SearchTable';
import Header from "./header/Header";
import Footer from "./footers/Footer";
import About from "./about/About";

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: []
        }
        this.search = this.search.bind(this);
    }

    findCommon = (array1, array2) => {
        if (array1 == null || array2 == null) {
            return false;
        }
        for (let i = 0; i < array1.length; i++) {
            if (!array2.includes(array1[i])) {
                return false;
            }
        }
        return true;
    }

    search = (name, depts, impacts, employments, majors, eTag) => {
        fetch(process.env.PUBLIC_URL + '/api/search/search', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name: name,
                departments: depts,
                impacts: impacts,
                employments: employments,
                majors: majors,
                eTag: eTag
            })
        }).then(response => response.json()).then(data => {

            let array = [];
            for (let row in data) {
                if ((depts.length === 0 || this.findCommon(depts, data[row].departments))
                    && (impacts.length === 0 || this.findCommon(impacts, data[row].impacts))
                    && (employments.length === 0 || this.findCommon(employments, data[row].employments))
                    && (majors.length === 0 || this.findCommon(majors, data[row].majors))
                    && (eTag == null || data[row].eTag === eTag)) {

                    array.push(data[row]);
                }
            }

            this.setState({items: array});
        });
    }

    render() {
        return (
            <div>
                <Header/>
                <About/>
                <div style={{
                    width: '80%',
                    margin: '0 auto'
                }}>
                    <SearchForm search={this.search}/>
                    <SearchTable items={this.state.items}/>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js